export default {
    state: {
        serials: [],
        pagination: {},
        isFetchingSerials: true,
    },
    mutations: {
        setSerials(state, serials) {
            state.serials = serials
        },
        addSerial(state, serial) {
            state.serials.unshift(serial)
        },
        removeSerial(state, serialId) {
            state.serials = state.serials.filter(serial => serial.id !== serialId)
        },
        setPagination(state, pagination) {
            state.pagination = pagination
        },
        setIsFetching(state, isFetching = false) {
            state.isFetchingSerials = isFetching;
        },
        updateSerial(state, serial) {
            const index = state.serials.findIndex(serial => serial.id === serial.id)
            Vue.set(state.serials, index, serial)
        },
    },
    getters: {
        listSerials: state => state.serials,
        serialPagination: state => state.pagination,
        isFetchingSerials: state => state.isFetchingSerials,
        findSerial: state => id => state.serials.find(serial => serial.id === id)
    },
    actions: {
        loadSerials(context, params) {
            context.commit('setIsFetching', true);
            const itemId = params.itemId;
            delete params.itemId;

            window.axios.get(`/api/items/${itemId}/serials`, { params })
                .then(({ data }) => {
                    context.commit('setSerials', data.data)
                    context.commit('setPagination', data.meta)
                    context.commit('setIsFetching', false);
                })
                .catch(error => {
                    console.error(error)
                    context.commit('setIsFetching', true);
                });
        },
        updateSerial(context, payload) {
            context.commit('updateSerial', payload)
        },
        addSerial(context, payload) {
            context.commit('addSerial', payload)
        },
        removeSerial(context, itemId) {
            context.commit('removeSerial', itemId)
        },
        startLoadingSerials({ commit }) {
            commit('setIsFetching', true);
        },
    }
}
